import Logo from "../../components/Logo";
import Campo from "../../components/Campo";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import CampoSenha from "../../components/Campo/CampoSenha";
import { UserContext } from "../../context/UserContext";
import logarAdmin from "../../services/logarAdmin";

function Login() {
  const navigate = useNavigate();
  const [userLogin, setLogin] = useState("");
  const [userPassword, setPassword] = useState("");
  const [shouldShowError, setShowError] = useState(false);

  const { setExp, setAuthTime, setEmail, setName, setToken, isSessionValid } =
    useContext(UserContext);
  useEffect(() => {
    if (isSessionValid()) {
      navigate("/instituicoes");
    }
  });

  return (
    <section className={styles.background_section}>
      <div className={styles.login_container}>
        <form>
          <Logo shadow={true} />

          <Campo
            title="Login"
            type="text"
            placeholder="Digite seu login"
            maxLength={128}
            required={true}
            value={userLogin}
            customValidity="Preencha com o seu Login"
            setter={setLogin}
            hideAsterisk={true}
          ></Campo>
          <CampoSenha
            title="Senha"
            placeholder="Digite sua Senha"
            value={userPassword}
            customValidity="Preencha com a sua Senha"
            setter={setPassword}
            hideAsterisk={true}
          />
          {shouldShowError && (
            <p className={styles.error}>Login ou senha invalidos</p>
          )}
          <input
            type="submit"
            value="Entrar"
            className={styles.submit_button}
            onClick={(e) => {
              e.preventDefault();
              const form = e.currentTarget.form;
              if (form) {
                const login = Array.from(form.elements)[0] as HTMLInputElement;
                const senha = Array.from(form.elements)[1] as HTMLInputElement;

                logarAdmin(login.value, senha.value)
                  .then(async (userCredential) => {
                    const { admin, token } = userCredential;
                    if (token) {
                      const authTime = Date.now();
                      const expirationTime = token.accessToken.expires_at;
                      setToken(token.plainTextToken || "");
                      setExp(new Date(expirationTime).getTime());
                      setAuthTime(new Date(authTime).getTime());
                      setName(admin.name || "");
                      setEmail(admin.email || "");
                      navigate("/instituicoes");
                    }
                  })
                  .catch((err) => {
                    const { code, message } = err;
                    console.log(code, message);
                    setShowError(true);
                    setLogin("");
                    setPassword("");
                  });
              }
            }}
          />
        </form>
      </div>
    </section>
  );
}
export default Login;
